import { notification } from 'antd';
import { AxiosError } from 'axios';
import Axios from '../../../axios/axios';

export const getFieldTask = (id: number) => async (dispatch) => {
    dispatch({
        type: 'LOADING_FIELDS_TASKS',
        payload: true,
    });

    try {
        const response = await Axios.get(`/fieldTask?taskConfigId=${id}`);

        if (response.data.message !== 'There are not tasks to show') {
            response.data = response.data;
        } else {
            response.data = [];
        }

        console.log(response, 'response');

        dispatch({
            type: 'GET_FIELDS_TASKS',
            payload: response?.data,
        });

        dispatch({
            type: 'LOADING_FIELDS_TASKS',
            payload: false,
        });
    } catch (error) {
        notification.error({
            message: 'Ocurrio un error.',
            description: '¡No se pudieron cargar las tareas!',
        });

        dispatch({
            type: 'LOADING_FIELDS_TASKS',
            payload: false,
        });
    }
};
